import { createContext, useReducer } from "react";

export const UnPhotoContext = createContext();

export const unPhotoReducer = (state, action) => {
    switch (action.type) {
        case 'SET_UN_PHOTO':
            return {
                unPhoto: action.payload
            }
        case 'CREATE_UN_PHOTO':
            return {
                unPhoto: [action.payload, ...state.unPhoto]
            }
        case 'DELETE_UN_PHOTO':
            return {
                unPhoto: state.unPhoto.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const UnPhotoContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(unPhotoReducer, {
        unPhoto: null
    });

    return (
        <UnPhotoContext.Provider value={{ ...state, dispatch }}>
            {children}
        </UnPhotoContext.Provider>
    );
};